/* eslint-disable react/prop-types */ function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import cn from 'classnames';
import _ from 'lodash/fp';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { components } from 'react-select';
import { setCurrentProject } from '../../../redux/actions';
import { getProjectName } from '../../../utilities/project';
import { isUserAnonymous } from '../../../utilities/user';
import Select from '../Select';
var Label = function(param) {
    var children = param.children, className = param.className;
    return /*#__PURE__*/ React.createElement("h6", {
        className: cn('JobLabel', _define_property({}, className, className))
    }, children);
};
var SingleValue = function(_param) {
    var children = _param.children, rest = _object_without_properties(_param, [
        "children"
    ]);
    return /*#__PURE__*/ React.createElement(components.SingleValue, _object_spread({
        className: "JobSelectControl"
    }, rest), /*#__PURE__*/ React.createElement(Label, null, children));
};
var NavProjectSelect = function(param) {
    var projects = param.projects, isLoading = param.isLoading, _param_onProjectChange = param.onProjectChange, onProjectChange = _param_onProjectChange === void 0 ? _.noop : _param_onProjectChange, _param_filterPredicate = param.filterPredicate, filterPredicate = _param_filterPredicate === void 0 ? _.stubTrue : _param_filterPredicate;
    var dispatch = useDispatch();
    var _useState = _sliced_to_array(useState([]), 2), options = _useState[0], setOptions = _useState[1];
    var currentProject = useSelector(function(state) {
        return state.project;
    }).currentProject;
    var userProfile = useSelector(function(state) {
        return state.profileReducer;
    }).userProfile;
    useEffect(function() {
        setOptions(_.filter(filterPredicate, projects));
    }, [
        projects
    ]);
    return isUserAnonymous(userProfile) ? /*#__PURE__*/ React.createElement(Label, {
        className: "JobSelect"
    }, getProjectName(currentProject)) : /*#__PURE__*/ React.createElement(Select, {
        options: options,
        value: currentProject,
        onChange: function(option) {
            onProjectChange(option, currentProject);
            dispatch(setCurrentProject(option));
        },
        getOptionLabel: function(option) {
            return getProjectName(option);
        },
        getOptionValue: function(option) {
            return option.id;
        },
        formatOptionLabel: function(option) {
            return getProjectName(option);
        },
        className: "JobSelect",
        components: {
            SingleValue: SingleValue
        },
        isDisabled: isLoading,
        isLoading: isLoading
    });
};
export default NavProjectSelect;
